import React from 'react'
import PropTypes from 'prop-types'
import { Hyperlink, Subheading, useMediaQuery } from '@offerzen/pinata-shame'
import HyperlinkExternalIcon from '@offerzen/zenicon/HyperlinkExternalIcon'

import AccessibleIcon from '@/CandidateExperience/components/AccessibleIcon'

import styles from './styles'

const Header = ({ companyImage, companyBackgroundColor, positionName, companyName, companySlug, isProfilePublished }) => {
  const { isTabletOrLarger } = useMediaQuery()

  return (
    <section className={styles.header}>
      <If condition={isTabletOrLarger}>
        <div className={styles.companyImage} style={{ backgroundColor: companyBackgroundColor }}>
          <img src={companyImage} alt="" width="71" height="71" />
        </div>
      </If>

      <div className={styles.details}>
        <Subheading className={styles.positionName}>{positionName}</Subheading>
        <p className={styles.companyName}>{companyName}</p>

        <If condition={isProfilePublished}>
          <Hyperlink
            className={styles.companyProfileLink}
            external
            label={
              <>
                View company profile <AccessibleIcon icon={HyperlinkExternalIcon} />
              </>
            }
            href={`/companies/${companySlug}`}
            target="_blank"
          />
        </If>
      </div>
    </section>
  )
}

Header.propTypes = {
  companyImage: PropTypes.string,
  positionName: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  companySlug: PropTypes.string.isRequired,
  companyBackgroundColor: PropTypes.string,
  isProfilePublished: PropTypes.bool,
}

export default Header
